export default __webpack_public_path__ + "static/media/pixabay.14241fa8.jpg";